<template>
  <div class="table-container-main">
    <div class="confirm-svg">
        <svg version="1.1" id="Layer_2_00000017498551833638599530000000546862870078238139_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 244 164" xml:space="preserve" data-v-24f3d49d=""><g id="_Ñëîé_1" data-v-24f3d49d=""><g data-v-24f3d49d=""><g data-v-24f3d49d=""><path class="st0" d="M4,110v16c0,5.5,4.5,10,10,10h30" data-v-24f3d49d=""></path><path class="st0" d="M92,136h50c5.5,0,10-4.5,10-10V14c0-5.5-4.5-10-10-10H23" data-v-24f3d49d=""></path><path class="st0" d="M27,4H14C8.5,4,4,8.5,4,14v100" data-v-24f3d49d=""></path><circle class="st0" cx="68" cy="136" r="24" data-v-24f3d49d=""></circle><circle class="st0" cx="196" cy="136" r="24" data-v-24f3d49d=""></circle><line class="st0" x1="128" y1="136" x2="172" y2="136" data-v-24f3d49d=""></line><path class="st0" d="M220,136h10c5.5,0,10-4.5,10-10V87.9c0-2.5-0.9-4.9-2.6-6.8L199,39.2c-1.9-2.1-4.6-3.2-7.4-3.2H152" data-v-24f3d49d=""></path><path class="st0" d="M240,84h-50c-5.5,0-10-4.5-10-10V48" data-v-24f3d49d=""></path></g></g></g><image width="507" height="492" xlink:href="data:image/png;base64,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" transform="matrix(9.068223e-02 0 0 9.068223e-02 10.352 11.3701)" data-v-24f3d49d="" style="overflow: visible;"></image></svg>
        <h2>Vehicles</h2>
    </div>
    <div class="responsive-table">
        <div class="table-header" id="header">
            <div class="col-1">Vehicle Code</div>
            <div class="col-2">Plate Number</div>
            <div class="col-3">Vehicle ID</div>
            <div class="col-4">Is Active</div>
        </div>
        <loading-charts v-if="loadingTable" class="loading-charts"/>
        <div class="table-row-container">
            <div class="table-row" v-for="(vehicle, index) in vehicleListData" :key="index">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text" @click="getUserDataClick(vehicle.vehicleCode)">{{vehicle.vehicleCode}}</p></div>
                <div class="col-2 col-data">{{vehicle.plateNumber}}</div>
                <div class="col-3 col-data"><p class="service-text">{{vehicle.vehicleID}}</p></div>
                <div class="col-4"><p>{{vehicle.isActive}}</p></div>
            </div>
            <div v-if="vehicleListData.length == 0" class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Vehicles</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
  </div>
  <div v-if="this.$route.name != 'UserDashboard'" class="button-container">
    <div class="print-selected close-label">
        <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
    </div>
  </div>
<vehicle-info v-if="toggleAddressBookInfo" @closeAddressInfo="closeAddressInfo($event)" :dropBoxCode="dropBoxCode"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import VehicleInfo from '../VehicleDashboard/VehicleInfo.vue'
import jsonexport from 'jsonexport'

export default {
    components:{
        AlertUser,
        LoadingCharts,
        VehicleInfo
    },
    props: ['userData', 'jwtToken', 'selectedUserData'],
    watch:{
        'userData':function(){
            if(this.userData)
            {
                this.getDropboxData();
            }else{
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user data to generate table."
            }
        }
    },
    mounted(){
        if(this.userData){
            this.getDropboxData(); 
        }
    },
    data(){
        return{
            toggleAddressBookInfo: false,
            id: null,
            dropBoxCode: null,
            vehicleListData: [],
            loadingTable: false,
            toggleAlertBox: '',
            alertMessage: '',
            selectedIndex: null
        }
    },
    methods:{
        isChecked(vehicleCodeSelect){
            if(this.selectedUserData.locationID == vehicleCodeSelect){
                return true;
            }else{
                return false;
            }
        },
        checkBoxSelectID(locationID, index){
            this.$emit('checkBoxSelectID', locationID)
            let checkbox = document.querySelectorAll("#selectIDCheckBox");
            this.selectedIndex = index;
            checkbox.forEach(element => {
                element.checked = false;
            });

            checkbox[index].checked = true;
        },
        async getUserDataClick(id){
            this.dropBoxCode = id;
            this.toggleAddressBookInfo = true;
        },
        closeAddressInfo(event){
            this.toggleAddressBookInfo = event;
            this.getDropboxData();
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async getDropboxData(){
            this.loadingTable = true;
            let graphqlQuery = `query listVehicles{
                listVehicles{
                items{
                    vehicleCode
                    vehicleID
                    plateNumber
                    isActive
                }
            }
            }`
            
            try{
                let getVehicleDataReturn = await API.graphql({
                query:  graphqlQuery,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                
                this.vehicleListData = getVehicleDataReturn.data.listVehicles.items;
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting vehicles"
                }
            }finally{
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        async downloadCSVTest(){
            this.loadingTable = true;
            let csvArray;
            csvArray = this.vehicleListData.map(obj =>{
                return {
                    vehicleCode: obj.vehicleCode,
                    vehicleID: obj.vehicleID,
                    plateNumber: obj.plateNumber,
                    isActive: obj.isActive
                }
            })
            jsonexport(csvArray, (error, csv) => {
                if (error) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error downloading vehicle data"
                }
                const blob = new Blob([csv], { type: 'text/csv' });
                const anchor = document.createElement('a');
                anchor.href = window.URL.createObjectURL(blob);
                anchor.download = 'Vehicles.csv';
                anchor.click();
                window.URL.revokeObjectURL(anchor.href);
                anchor.remove();
                this.loadingTable = false;
            })
        }
    }
}
</script>

<style scoped>
.st0{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}

h3{
    margin: 0;
}
.table-container-main{
    width: 100%;
    margin-top: 0;
    overflow-x: hidden;
}

.responsive-table{
    width: 100%;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
    margin-bottom: 5px;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

* {
    scrollbar-width: auto;
    scrollbar-color: #f3f3f3 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
    width: 16px;
}

*::-webkit-scrollbar-track {
    background: #ffffff;
}

*::-webkit-scrollbar-thumb {
    background-color: #f3f3f3;
    border-radius: 10px;
    border: 3px solid #ffffff;
}

.table-header{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #32ccfe;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
    color: #fff;
}

.table-row-container{
    max-height: 350px;
    overflow-y: auto;
    border-radius: 5px;
    width: 100%;
    animation: animate-table-row 1s ease;
}

@keyframes animate-table-row{
    from{
        margin-left: -50px;
    }
    to{
        margin-left: 0px;
    }
}

.table-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f3f3f3;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
}

.table-header .col-1{
    margin-right: 5px;
}

.col-1{
    flex-basis: 20%;
    text-align: left;
    /* white-space: nowrap; */
}

.col-2{
    flex-basis: 40%;
    text-align: left;
    margin-left: 5px;
}

.col-3{
    flex-basis: 30%;
    text-align: left;
    margin-left: 5px;
}

.col-data{
    text-align: left;
}

.col-4{
    flex-basis: 10%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.service-text{
    background-color: #d4d4d4;
    padding: 2.5px 10px;
    border-radius: 999px;
    width: fit-content;
    margin: 0;
    font-size: 12px;
}

.shipmentid-text{
    margin: 0;
    color: #6a6a6a;
    width: fit-content;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.shipmentid-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.button-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    animation: animate-table-row 1s ease;
}

.print-selected-text{
    margin: 0;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.download-csv{
    margin-top: 5px;
}

.void-selected-text{
    margin: 0;
    margin-bottom: 5px;
    padding: 2.5px 10px;
    margin-bottom: 5px;
    border-radius: 999px;
    background-color: #fe804d;
    border: 1px solid #ff5512;
    color: #fff;
    transition-duration: .5s;
}

.print-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.void-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.close-label{
    margin-left: auto;
}

.label-container{
    width: 100%;
}

@media only screen and (max-width: 600px) {
    .service-text, .col-data{
        font-size: 8px;
    }

    .col-4 p{
        font-size: 8px;
    }

    .shipmentid-text{
        font-size: 10px;
    }
}

@media only screen and (max-width: 1135px) {
   .col-1{
        min-width: 30%;
    }
}
</style>